<template>
  <div class="ServiceAgreement_wraper">
    <div v-html="AgreemnetData"></div>
    <div class="ServiceAgreement_wraper_margin"></div>
  </div>
</template>

<script>

export default {
  name: "serviceAgreement",
  components: {},
  data() {
    return {
      AgreemnetData: "" ///..获取的服务端提供的HTML数据（用户使用协议）
    };
  },
  computed: {},
  methods: {
    requestAgreement() {
      ///用户使用协议点击事件
      this.$request({
        method: "post",
        ///请求参数  0用户服务协议
        url: "/config/findAppAgreementByType",
        data: { type: "0" }
      })
        .then(res => {
          ////请求成功的回调
          this.AgreemnetData = res.data.data.content;
          console.log(this.AgreemnetData);
        })
        .catch(err => {
          ////失败的回调
          console.log(err);
        });
    }
  },
  beforeCreate() {
    ///钩子函数：vue实例的挂载元素$el和数据对象data都为undefined，还未初始化。
    document.title = "服务协议"; // 修改title
  },
  created() {
    ///钩子函数: vue实例的数据对象data有了，$el还没有
  },
  beforeMount() {
    ///钩子函数: vue实例的$el和data都初始化了，但还是虚拟的dom节点，具体的data.filter还未替换。
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    this.requestAgreement();
  },
  beforeDestroy() {
    // 挂掉之前
    document.title = "智控系统"; // 修改title
  }
};
</script>

<style  >
.ServiceAgreement_wraper {
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  /* padding-bottom: 50px; */
  /* margin-bottom: 50px; */
}
.ServiceAgreement_wraper_margin {
  height: 50px;
}
.ServiceAgreement_wraper h1 {
  font-size: 25px;
  margin-bottom: 20px;
}
.ServiceAgreement_wraper h1 {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 20px;
}
.ServiceAgreement_wraper h2 {
    font-size: 20px;
    margin-bottom: 15px;
    font-weight: bold;
}
.ServiceAgreement_wraper h3 {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
}
.ServiceAgreement_wraper strong {
    font-weight: bold;
}

</style>
